import { getBaseFeature, pxToRem } from '@/assets/style/variable'

const bannerBgSize = `${pxToRem(375)} ${pxToRem(410)}`

const styObj = {
  default: {
    '--hr-head-bg': `url(${require('./images/h-head.webp')}) left top / 100% auto no-repeat`,
    '--hr-banner-bg': `url(${require('./images/h-head.webp')}) top left / ${bannerBgSize} no-repeat`,
    '--hr-rank-head-gradient': 'linear-gradient(90deg, rgba(117, 75, 246, 0) 0%, #7c53ff 54.44%, rgba(117, 75, 246, 0) 100%)',
    '--hr-theme-color': '#a338fc',
    '--hr-date-btn-bg': '#e8e1ff',
    '--hr-owner-bar-bg': '#e8e1ff',
    '--hr-dia-btn-bg': '#a338fc',
    '--hr-rules-dia-bg': `url(${require('./images/d-rulebg.webp')}) center center / 100% 100% no-repeat`,
    '--hr-rules-dia-con-bg': 'rgba(118, 66, 255, 0.8)',
    '--hr-rules-dia-field-color': '#ffffff',
    '--hr-rules-dia-reward-color': '#fdca0f',
    '--hr-rules-dia-btn-bg': 'linear-gradient(90deg, #8828ff 0%, #8561ff 100%)',
  },

  kiko: {
    '--hr-head-bg': `url(${require('./images/h-head-kiko.webp')}) left top / 100% auto no-repeat`,
    '--hr-banner-bg': `url(${require('./images/h-head-kiko.webp')}) top left / ${bannerBgSize} no-repeat`,
    '--hr-rank-head-gradient': 'linear-gradient(90deg, rgba(255, 56, 56, 0) 0%, #ff3838 54.44%, rgba(255, 56, 56, 0) 100%)',
    '--hr-theme-color': '#b79b21',
    '--hr-date-btn-bg': '#fffce6',
    '--hr-owner-bar-bg': '#ffe242',
    '--hr-dia-btn-bg': '#ffe242',
    '--hr-rules-dia-bg': `url(${require('./images/d-rulebg-kiko.webp')}) center center / 100% 100% no-repeat`,
    '--hr-rules-dia-con-bg': 'rgba(255, 255, 255, 0.2)',
    '--hr-rules-dia-field-color': '#000000',
    '--hr-rules-dia-reward-color': '#fffce6',
    '--hr-rules-dia-btn-bg': '#000000',
  },
}

export const pageCssVars = {
  methods: {
    cssVars() {
      if (this.packageName) {
        if (styObj[this.packageName]) {
          return { ...getBaseFeature(), ...styObj[this.packageName] }
        }
        return { ...getBaseFeature(), ...styObj.default }
      }
      return { ...getBaseFeature() }
    },
  },
}
